import { forwardRef, createElement } from 'react';

function IconArrowTop(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M11.86 8.013l.067-.01.125-.001.119.018.098.03.1.047.051.032.038.027.072.064 3.5 3.5a.75.75 0 01-.976 1.133l-.084-.073-2.22-2.219v8.189a.75.75 0 01-1.493.102l-.007-.102v-8.189l-2.22 2.22a.75.75 0 01-1.133-.977l.073-.084 3.5-3.5.042-.04.052-.04.114-.068.098-.038.084-.02zM15.75 4.5a.75.75 0 110 1.5h-7.5a.75.75 0 010-1.5h7.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var ArrowTop = /*#__PURE__*/forwardRef(IconArrowTop);

export default ArrowTop;
//# sourceMappingURL=ArrowTop.js.map
